import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Examples = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();

    const examples = [
        {
            id: 1,
            title: "Düğünümüze davetlisiniz!",
            couple: "Cansu & Mert",
            category: "Düğün",
            theme: "classic",
            bgGradient: "from-slate-50 to-slate-100",
            accent: "rose",
            features: ["Müzik", "Galeri", "Konum", "Mektup"]
        },
        {
            id: 2,
            title: "Modern Nişan",
            couple: "Zeynep & Ali",
            category: "Nişan",
            theme: "modern",
            bgGradient: "from-purple-100 via-violet-50 to-indigo-100",
            accent: "purple",
            features: ["Program", "Tebrik", "Anket", "Konum"]
        },
        {
            id: 3,
            title: "Doğum Günü",
            couple: "Ayşe'nin 2. Yaşı",
            category: "Doğum Günü",
            theme: "colorful",
            bgGradient: "from-yellow-100 via-orange-50 to-pink-100",
            accent: "orange",
            features: ["Oyunlar", "Hediye", "Müzik", "Fotoğraf"]
        },
        {
            id: 4,
            title: "Geleneksel Kına",
            couple: "Fatma'nın Kınası",
            category: "Kına Gecesi",
            theme: "traditional",
            bgGradient: "from-amber-100 via-yellow-50 to-orange-100",
            accent: "amber",
            features: ["Motifler", "Müzik", "Dans", "Yemek"]
        },
        {
            id: 5,
            title: "Kurumsal Etkinlik",
            couple: "Tech Summit 2025",
            category: "Kurumsal",
            theme: "professional",
            bgGradient: "from-slate-100 via-gray-50 to-blue-100",
            accent: "slate",
            features: ["Tarih & Saat", "Mekan", "Ek Bilgiler", "Konum"]
        },
        {
            id: 6,
            title: "Mezuniyet Töreni",
            couple: "Sınıf 2024",
            category: "Özel Gün",
            theme: "celebration",
            bgGradient: "from-emerald-100 via-green-50 to-teal-100",
            accent: "emerald",
            features: ["Anılar", "Video", "Sertifika", "Kutlama"]
        }
    ];

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % examples.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + examples.length) % examples.length);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    // Otomatik slider
    useEffect(() => {
        const interval = setInterval(nextSlide, 5000);
        return () => clearInterval(interval);
    }, []);

    const getVisibleExamples = () => {
        const visibleCount = 3; // Desktop'ta 3 telefon göster
        const visible = [];

        for (let i = 0; i < visibleCount; i++) {
            const index = (currentSlide + i) % examples.length;
            visible.push({ ...examples[index], position: i });
        }

        return visible;
    };

    return (
        <section id="ornekler" className="relative py-20 lg:py-28 bg-gradient-to-b from-dark-50 via-white to-primary-50 overflow-hidden">
            {/* Arka plan dekoratif elementler */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-32 left-5 w-36 h-36 bg-primary-200 rounded-full opacity-10 animate-float"></div>
                <div className="absolute bottom-20 right-8 w-28 h-28 bg-dark-200 rounded-full opacity-15 animate-pulse-slow"></div>
                <div className="absolute top-1/4 right-1/3 w-20 h-20 bg-primary-100 rounded-full opacity-20 animate-bounce-slow"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                {/* Başlık bölümü */}
                <div className="text-center mb-16 animate-fade-in">
                    <div className="inline-block bg-gradient-to-r from-primary-100 to-primary-200 text-primary-800 px-6 py-3 rounded-full text-sm font-semibold mb-6 shadow-lg">
                        🎨 Çalışma Örnekleri
                    </div>
                    <h2 className="text-4xl lg:text-5xl font-bold text-dark-900 mb-4 animate-slide-up">
                        Unutulmaz Anlar İçin
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800 block mt-1 pt-2 pb-2 leading-relaxed">
                            İlham Veren Tasarımlar
                        </span>
                    </h2>
                    <p className="text-lg text-dark-600 max-w-3xl mx-auto leading-relaxed animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        Her biri özenle tasarlanmış dijital davetiyelerimizi keşfedin. Müşterilerimizin özel günleri için
                        oluşturduğumuz çalışmalardan ilham alın ve kendi davetiyenizi hayal edin.
                    </p>
                </div>

                {/* Telefon Slider */}
                <div className="relative">
                    {/* Telefon konteyneri */}
                    <div className="flex justify-center items-center min-h-[600px] animate-slide-up" style={{ animationDelay: '0.4s' }}>
                        <div className="relative w-full max-w-4xl">

                            {/* Mobile view - Tek telefon */}
                            <div className="block lg:hidden">
                                <div className="flex justify-center">
                                    {examples.slice(currentSlide, currentSlide + 1).map((example, index) => (
                                        <PhoneExample key={example.id} example={example} isCenter={true} navigate={navigate} />
                                    ))}
                                </div>
                            </div>

                            {/* Desktop view - Üç telefon */}
                            <div className="hidden lg:flex justify-center items-center space-x-6">
                                {getVisibleExamples().map((example, index) => (
                                    <PhoneExample
                                        key={`${example.id}-${example.position}`}
                                        example={example}
                                        isCenter={example.position === 1}
                                        isLeft={example.position === 0}
                                        isRight={example.position === 2}
                                        navigate={navigate}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Navigation Butonları */}
                    <button
                        onClick={prevSlide}
                        className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-dark-700 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-10"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>

                    <button
                        onClick={nextSlide}
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-dark-700 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-10"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>

                    {/* Dot Indicators */}
                    <div className="flex justify-center mt-12 space-x-3">
                        {examples.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToSlide(index)}
                                className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentSlide
                                    ? 'bg-primary-600 scale-125'
                                    : 'bg-dark-300 hover:bg-primary-400'
                                    }`}
                            />
                        ))}
                    </div>
                </div>

                {/* Alt CTA bölümü */}
                <div className="text-center mt-20 animate-slide-up" style={{ animationDelay: '0.8s' }}>
                    <div className="bg-gradient-to-r from-dark-800 to-dark-900 rounded-3xl p-8 lg:p-12 shadow-2xl text-white relative overflow-hidden">
                        {/* Arka plan pattern */}
                        <div className="absolute inset-0 opacity-10">
                            <div className="absolute top-4 right-4 w-40 h-40 bg-primary-500 rounded-full blur-3xl"></div>
                            <div className="absolute bottom-4 left-4 w-32 h-32 bg-white rounded-full blur-2xl"></div>
                        </div>

                        <div className="relative">
                            <h3 className="text-2xl lg:text-3xl font-bold mb-4">
                                Dijital Davetiyenizi Özenle Oluşturuyoruz
                            </h3>
                            <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
                                Yukarıdaki örneklerden beğendiğiniz bir tarzı seçerek bizimle iletişime geçebilirsiniz.
                                Uzman ekibimiz size yardımcı olmaya hazır!
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                <button
                                    onClick={() => {
                                        const element = document.getElementById('iletisim');
                                        if (element) {
                                            element.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }}
                                    className="bg-primary-600 text-white px-8 py-4 rounded-xl hover:bg-primary-700 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                                    İletişime Geç
                                </button>
                                <button
                                    onClick={() => {
                                        window.location.href = '/calismalarimiz';
                                    }}
                                    className="border-2 border-white text-white px-8 py-4 rounded-xl hover:bg-white hover:text-dark-900 transition-all duration-300 font-semibold">
                                    Daha Fazla Örnek
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// Telefon Component'i
const PhoneExample = ({ example, isCenter = false, isLeft = false, isRight = false, navigate }) => {
    const scale = isCenter ? 'scale-105' : isLeft || isRight ? 'scale-90' : 'scale-100';
    const zIndex = isCenter ? 'z-20' : 'z-10';
    const opacity = isCenter ? 'opacity-100' : 'opacity-75 hover:opacity-100';

    // Düğün kategorisi için özel tasarım
    if (example.category === "Düğün") {
        return (
            <div className={`relative transform transition-all duration-500 ${scale} ${zIndex} ${opacity}`}>
                {/* Telefon çerçevesi */}
                <div className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-[2.5rem] p-2 shadow-2xl hover:shadow-3xl transition-all duration-500">
                    <div className="bg-white rounded-[2rem] overflow-hidden w-60 h-[480px] relative shadow-inner">
                        {/* Telefon içeriği - Düğün tasarımı */}
                        <div className="bg-gradient-to-br from-gray-50 via-white to-gray-100 h-full flex flex-col p-4 relative overflow-hidden">

                            {/* Üst dekoratif çizgi */}
                            <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-dark-200 rounded-full"></div>

                            {/* Kategori etiketi */}
                            <div className="absolute top-6 right-3 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg backdrop-blur-sm border border-white/20 z-10">
                                Düğün
                            </div>

                            {/* Ana başlık */}
                            <div className="text-center mt-12 mb-4 z-10 relative">
                                <h2 className="text-xl font-bold text-dark-900 leading-tight">
                                    Cansu & Mert
                                </h2>
                                <p className="text-gray-600 text-xs mt-1">
                                    Düğünümüze davetlisiniz!
                                </p>
                            </div>

                            {/* Ana kalp ikonu */}
                            <div className="flex justify-center mb-4 z-10 relative">
                                <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center shadow-xl relative">
                                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                    </svg>
                                    {/* Küçük kalp */}
                                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-red-400 rounded-full flex items-center justify-center">
                                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* Tarih bilgisi */}
                            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-2 mb-3 shadow-lg z-10 relative border border-red-200">
                                <div className="text-center mb-2">
                                    <p className="text-xs text-red-600">Düğün Tarihi</p>
                                    <p className="text-sm font-bold text-dark-900">25 Ağustos 2025</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-xs text-red-600">Saat & Mekan</p>
                                    <p className="text-sm font-medium text-dark-800">Cumartesi, 16:00</p>
                                </div>
                            </div>

                            {/* Özellikler grid */}
                            <div className="grid grid-cols-2 gap-2 mb-3 z-10 relative">
                                <div className="flex items-center justify-center bg-white/80 rounded-xl p-1.5 shadow-sm border border-gray-200">
                                    <div className="w-2 h-2 bg-red-500 rounded-full mr-1.5"></div>
                                    <span className="text-xs font-medium text-gray-700">Müzik</span>
                                </div>
                                <div className="flex items-center justify-center bg-white/80 rounded-xl p-1.5 shadow-sm border border-gray-200">
                                    <div className="w-2 h-2 bg-red-500 rounded-full mr-1.5"></div>
                                    <span className="text-xs font-medium text-gray-700">Galeri</span>
                                </div>
                                <div className="flex items-center justify-center bg-white/80 rounded-xl p-1.5 shadow-sm border border-gray-200">
                                    <div className="w-2 h-2 bg-red-500 rounded-full mr-1.5"></div>
                                    <span className="text-xs font-medium text-gray-700">Konum</span>
                                </div>
                                <div className="flex items-center justify-center bg-white/80 rounded-xl p-1.5 shadow-sm border border-gray-200">
                                    <div className="w-2 h-2 bg-red-500 rounded-full mr-1.5"></div>
                                    <span className="text-xs font-medium text-gray-700">RSVP</span>
                                </div>
                            </div>

                            {/* Görüntüle butonu */}
                            <div className="flex justify-center mt-auto mb-4 z-10 relative">
                                <button
                                    onClick={() => navigate('/calismalarimiz?category=wedding')}
                                    className="bg-red-500 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                                    Görüntüle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Çevredeki dekoratif elementler */}
                <div className="absolute -top-3 -right-3 bg-red-400 rounded-full w-6 h-6 opacity-40 animate-bounce-slow"></div>
                <div className="absolute -bottom-4 -left-4 bg-pink-300 rounded-full w-8 h-8 opacity-30 animate-float"></div>
            </div>
        );
    }

    // Doğum Günü kategorisi için özel tasarım
    if (example.category === "Doğum Günü") {
        return (
            <div className={`relative transform transition-all duration-500 ${scale} ${zIndex} ${opacity}`}>
                {/* Telefon çerçevesi */}
                <div className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-[2.5rem] p-2 shadow-2xl hover:shadow-3xl transition-all duration-500">
                    <div className="bg-white rounded-[2rem] overflow-hidden w-60 h-[480px] relative shadow-inner">
                        {/* Telefon içeriği - Doğum günü tasarımı */}
                        <div className="bg-gradient-to-br from-yellow-50 via-orange-50 to-pink-50 h-full flex flex-col p-4 relative overflow-hidden">

                            {/* Üst dekoratif çizgi */}
                            <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-dark-200 rounded-full"></div>

                            {/* Kategori etiketi */}
                            <div className="absolute top-6 right-3 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg backdrop-blur-sm border border-white/20 z-10">
                                Doğum Günü
                            </div>

                            {/* Ana başlık */}
                            <div className="text-center mt-12 mb-4 z-10 relative">
                                <h2 className="text-xl font-bold text-dark-900 leading-tight">
                                    Ayşe'nin 5. Yaşı
                                </h2>
                                <p className="text-orange-600 text-xs mt-1">
                                    Doğum gününe davetlisiniz!
                                </p>
                            </div>

                            {/* Ana pasta ikonu */}
                            <div className="flex justify-center mb-4 z-10 relative">
                                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center shadow-xl relative">
                                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 1l-1.71 1.97c-.19.3-.29.65-.29 1.03 0 1.1.89 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07L7.4 15.99C8.7 17.3 10.98 17.3 12.28 16c1.3 1.3 3.58 1.3 4.89 0-.01 0-.01 0 0 0zM12 9c-4.97 0-9 1.67-9 3.75V16c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-3.25C21 10.67 16.97 9 12 9z" />
                                    </svg>
                                    {/* Mum ikonu */}
                                    <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-1 h-4 bg-yellow-400 rounded-full"></div>
                                    <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-red-400 rounded-full"></div>
                                </div>
                            </div>

                            {/* Tarih bilgisi */}
                            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-2 mb-3 shadow-lg z-10 relative border border-orange-200">
                                <div className="text-center mb-2">
                                    <p className="text-xs text-orange-600">Parti Tarihi</p>
                                    <p className="text-sm font-bold text-dark-900">19 Temmuz 2025</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-xs text-orange-600">Saat & Mekan</p>
                                    <p className="text-sm font-medium text-dark-800">Cumartesi, 18:00</p>
                                </div>
                            </div>

                            {/* Özellikler grid */}
                            <div className="grid grid-cols-2 gap-2 mb-3 z-10 relative">
                                <div className="flex items-center justify-center bg-white/80 rounded-xl p-1.5 shadow-sm border border-orange-200">
                                    <div className="w-2 h-2 bg-orange-500 rounded-full mr-1.5"></div>
                                    <span className="text-xs font-medium text-gray-700">Oyunlar</span>
                                </div>
                                <div className="flex items-center justify-center bg-white/80 rounded-xl p-1.5 shadow-sm border border-orange-200">
                                    <div className="w-2 h-2 bg-orange-500 rounded-full mr-1.5"></div>
                                    <span className="text-xs font-medium text-gray-700">Hediye</span>
                                </div>
                                <div className="flex items-center justify-center bg-white/80 rounded-xl p-1.5 shadow-sm border border-orange-200">
                                    <div className="w-2 h-2 bg-orange-500 rounded-full mr-1.5"></div>
                                    <span className="text-xs font-medium text-gray-700">Müzik</span>
                                </div>
                                <div className="flex items-center justify-center bg-white/80 rounded-xl p-1.5 shadow-sm border border-orange-200">
                                    <div className="w-2 h-2 bg-orange-500 rounded-full mr-1.5"></div>
                                    <span className="text-xs font-medium text-gray-700">Fotoğraf</span>
                                </div>
                            </div>

                            {/* Görüntüle butonu */}
                            <div className="flex justify-center mt-auto mb-4 z-10 relative">
                                <button
                                    onClick={() => navigate('/calismalarimiz?category=birthday')}
                                    className="bg-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                                    Görüntüle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Çevredeki dekoratif elementler */}
                <div className="absolute -top-3 -right-3 bg-orange-400 rounded-full w-6 h-6 opacity-40 animate-bounce-slow"></div>
                <div className="absolute -bottom-4 -left-4 bg-yellow-300 rounded-full w-8 h-8 opacity-30 animate-float"></div>
            </div>
        );
    }

    // Nişan kategorisi için özel tasarım
    if (example.category === "Nişan") {
        return (
            <div className={`relative transform transition-all duration-500 ${scale} ${zIndex} ${opacity}`}>
                <div className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-[2.5rem] p-2 shadow-2xl hover:shadow-3xl transition-all duration-500">
                    <div className="bg-white rounded-[2rem] overflow-hidden w-60 h-[480px] relative shadow-inner">
                        <div className="bg-gradient-to-br from-purple-50 via-violet-50 to-indigo-50 h-full flex flex-col p-4 relative overflow-hidden">

                            {/* Arka plan dekoratif elementler */}
                            <div className="absolute top-4 right-4 w-16 h-16 bg-purple-200 rounded-full opacity-20 animate-pulse-slow"></div>
                            <div className="absolute bottom-8 left-4 w-12 h-12 bg-violet-200 rounded-full opacity-25 animate-float"></div>

                            {/* Üst dekoratif çizgi */}
                            <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-dark-200 rounded-full"></div>

                            {/* Kategori etiketi */}
                            <div className="absolute top-6 right-3 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg backdrop-blur-sm border border-white/20 z-10">
                                Nişan
                            </div>

                            {/* Yüzük ikonları */}
                            <div className="flex justify-center mt-12 mb-3">
                                <div className="relative">
                                    <div className="w-8 h-8 border-4 border-purple-500 rounded-full relative">
                                        <div className="absolute top-1 left-1 w-2 h-2 bg-purple-500 rounded-full"></div>
                                    </div>
                                    <div className="absolute -right-3 top-1 w-6 h-6 border-3 border-violet-500 rounded-full">
                                        <div className="absolute top-0.5 left-0.5 w-1.5 h-1.5 bg-violet-500 rounded-full"></div>
                                    </div>
                                </div>
                            </div>

                            {/* Çift ismi */}
                            <div className="text-center mb-4 z-10 relative">
                                <h2 className="text-2xl font-serif text-dark-900 mb-1">
                                    Zeynep & Ali
                                </h2>
                                <p className="text-purple-600 text-sm font-medium">
                                    Nişan törenimize davetlisiniz
                                </p>
                            </div>

                            {/* Tarih */}
                            <div className="text-center mb-6 z-10 relative">
                                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-3 shadow-lg">
                                    <p className="text-xs text-dark-600 mb-1">Tarih</p>
                                    <p className="text-lg font-bold text-dark-900">15 Haziran 2025</p>
                                    <p className="text-sm text-dark-700">Cumartesi, 19:00</p>
                                </div>
                            </div>

                            {/* Aile bilgileri */}
                            <div className="flex justify-between text-center mb-4 px-2 z-10 relative">
                                <div className="bg-purple-100/80 rounded-lg p-2 flex-1 mr-1">
                                    <p className="text-xs text-purple-800 font-medium">Kız Tarafı</p>
                                    <p className="text-xs text-dark-700">Ayşe & Mehmet</p>
                                    <p className="text-xs text-dark-700">Yılmaz</p>
                                </div>
                                <div className="bg-violet-100/80 rounded-lg p-2 flex-1 ml-1">
                                    <p className="text-xs text-violet-800 font-medium">Erkek Tarafı</p>
                                    <p className="text-xs text-dark-700">Fatma & Ali</p>
                                    <p className="text-xs text-dark-700">Özkan</p>
                                </div>
                            </div>

                            {/* Görüntüle butonu */}
                            <div className="flex justify-center mt-auto mb-4 z-10 relative">
                                <button
                                    onClick={() => navigate('/calismalarimiz?category=engagement')}
                                    className="bg-purple-600 text-white px-8 py-2.5 rounded-full text-sm font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                                    Görüntüle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="absolute -top-3 -right-3 bg-purple-400 rounded-full w-6 h-6 opacity-40 animate-bounce-slow"></div>
                <div className="absolute -bottom-4 -left-4 bg-violet-300 rounded-full w-8 h-8 opacity-30 animate-float"></div>
            </div>
        );
    }

    // Kına Gecesi kategorisi için özel tasarım  
    if (example.category === "Kına Gecesi") {
        return (
            <div className={`relative transform transition-all duration-500 ${scale} ${zIndex} ${opacity}`}>
                <div className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-[2.5rem] p-2 shadow-2xl hover:shadow-3xl transition-all duration-500">
                    <div className="bg-white rounded-[2rem] overflow-hidden w-60 h-[480px] relative shadow-inner">
                        <div className="bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50 h-full flex flex-col p-4 relative overflow-hidden">

                            {/* Arka plan desenleri */}
                            <div className="absolute top-6 left-6 w-8 h-8 border-2 border-amber-300 rounded-full opacity-30"></div>
                            <div className="absolute bottom-12 right-6 w-12 h-12 border-2 border-orange-300 rounded-lg rotate-45 opacity-25"></div>
                            <div className="absolute top-1/3 right-4 w-6 h-6 bg-yellow-300 rounded-full opacity-40"></div>

                            {/* Üst dekoratif çizgi */}
                            <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-dark-200 rounded-full"></div>

                            {/* Kategori etiketi */}
                            <div className="absolute top-6 right-3 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg backdrop-blur-sm border border-white/20 z-10">
                                Kına Gecesi
                            </div>

                            {/* Kına el ikonu */}
                            <div className="flex justify-center mt-12 mb-3">
                                <div className="relative">
                                    <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center shadow-xl">
                                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2M21 9V7L15 1L13.5 2.5L16.75 5.75C14.4 6.1 12 7.65 12 10.5V22H22V10.5C22 9.65 21.65 9 21 9M11 22H2V10.5C2 7.65 4.6 6.1 6.25 5.75L9.5 2.5L8 1L2 7V9C1.35 9 1 9.65 1 10.5V22H11Z" />
                                        </svg>
                                        {/* Kına deseni noktaları */}
                                        <div className="absolute -top-1 -right-1 w-3 h-3 bg-orange-500 rounded-full"></div>
                                        <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-yellow-500 rounded-full"></div>
                                    </div>
                                </div>
                            </div>

                            {/* Ana başlık */}
                            <div className="text-center mb-4 z-10 relative">
                                <h2 className="text-2xl font-bold text-dark-900 leading-tight">
                                    Fatma'nın Kınası
                                </h2>
                                <p className="text-amber-700 text-sm font-medium mt-1">
                                    Geleneksel Kına Gecesi
                                </p>
                            </div>

                            {/* Etkinlik detayları */}
                            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-3 mb-4 shadow-lg z-10 relative">
                                <div className="grid grid-cols-2 gap-3 text-xs">
                                    <div className="text-center">
                                        <p className="text-amber-700 font-bold">Tarih</p>
                                        <p className="text-dark-800">20 Temmuz</p>
                                    </div>
                                    <div className="text-center">
                                        <p className="text-amber-700 font-bold">Saat</p>
                                        <p className="text-dark-800">20:00</p>
                                    </div>
                                </div>
                            </div>

                            {/* Özellikler */}
                            <div className="grid grid-cols-2 gap-2 mb-4 z-10 relative">
                                <div className="bg-amber-100/80 rounded-lg p-2 text-center">
                                    <p className="text-xs font-medium text-amber-800">Motifler</p>
                                </div>
                                <div className="bg-yellow-100/80 rounded-lg p-2 text-center">
                                    <p className="text-xs font-medium text-yellow-800">Müzik</p>
                                </div>
                                <div className="bg-orange-100/80 rounded-lg p-2 text-center">
                                    <p className="text-xs font-medium text-orange-800">Dans</p>
                                </div>
                                <div className="bg-red-100/80 rounded-lg p-2 text-center">
                                    <p className="text-xs font-medium text-red-800">Yemek</p>
                                </div>
                            </div>

                            {/* Görüntüle butonu */}
                            <div className="flex justify-center mt-auto mb-4 z-10 relative">
                                <button
                                    onClick={() => navigate('/calismalarimiz?category=henna')}
                                    className="bg-amber-600 text-white px-8 py-2.5 rounded-full text-sm font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                                    Görüntüle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="absolute -top-3 -right-3 bg-amber-400 rounded-full w-6 h-6 opacity-40 animate-bounce-slow"></div>
                <div className="absolute -bottom-4 -left-4 bg-orange-300 rounded-full w-8 h-8 opacity-30 animate-float"></div>
            </div>
        );
    }

    // Kurumsal kategorisi için özel tasarım
    if (example.category === "Kurumsal") {
        return (
            <div className={`relative transform transition-all duration-500 ${scale} ${zIndex} ${opacity}`}>
                <div className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-[2.5rem] p-2 shadow-2xl hover:shadow-3xl transition-all duration-500">
                    <div className="bg-white rounded-[2rem] overflow-hidden w-60 h-[480px] relative shadow-inner">
                        <div className="bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50 h-full flex flex-col p-4 relative overflow-hidden">

                            {/* Arka plan grid pattern */}
                            <div className="absolute inset-0 opacity-5">
                                <div className="grid grid-cols-8 gap-1 h-full">
                                    {Array.from({ length: 64 }).map((_, i) => (
                                        <div key={i} className="bg-slate-400"></div>
                                    ))}
                                </div>
                            </div>

                            {/* Üst dekoratif çizgi */}
                            <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-dark-200 rounded-full"></div>

                            {/* Kategori etiketi */}
                            <div className="absolute top-6 right-3 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg backdrop-blur-sm border border-white/20 z-10">
                                Kurumsal
                            </div>

                            {/* Şirket logosu placeholder */}
                            <div className="flex justify-center mt-12 mb-4">
                                <div className="w-16 h-16 bg-slate-600 rounded-lg flex items-center justify-center">
                                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 2l3.09 6.26L22 9l-5 4.87L18.18 21 12 17.77 5.82 21 7 13.87 2 9l6.91-1.74L12 2z" />
                                    </svg>
                                </div>
                            </div>

                            {/* Ana başlık */}
                            <div className="text-center mb-4 z-10 relative">
                                <h2 className="text-xl font-bold text-dark-900 leading-tight">
                                    Tech Summit 2025
                                </h2>
                                <p className="text-slate-600 text-sm font-medium mt-1">
                                    Kurumsal Etkinlik
                                </p>
                            </div>

                            {/* Etkinlik bilgileri */}
                            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-3 mb-4 shadow-lg z-10 relative border border-slate-200">
                                <div className="text-center mb-2">
                                    <p className="text-xs text-slate-600">Etkinlik Tarihi</p>
                                    <p className="text-sm font-bold text-dark-900">25 Ağustos 2025</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-xs text-slate-600">Konum</p>
                                    <p className="text-sm font-medium text-dark-800">İstanbul Kongre Merkezi</p>
                                </div>
                            </div>

                            {/* Özellikler grid */}
                            <div className="grid grid-cols-2 gap-2 mb-4 z-10 relative">
                                <div className="bg-slate-100/80 rounded-lg p-2 text-center border border-slate-200">
                                    <p className="text-xs font-medium text-slate-800">Program</p>
                                </div>
                                <div className="bg-blue-100/80 rounded-lg p-2 text-center border border-blue-200">
                                    <p className="text-xs font-medium text-blue-800">Katılım</p>
                                </div>
                                <div className="bg-indigo-100/80 rounded-lg p-2 text-center border border-indigo-200">
                                    <p className="text-xs font-medium text-indigo-800">Network</p>
                                </div>
                                <div className="bg-purple-100/80 rounded-lg p-2 text-center border border-purple-200">
                                    <p className="text-xs font-medium text-purple-800">Sunum</p>
                                </div>
                            </div>

                            {/* Görüntüle butonu */}
                            <div className="flex justify-center mt-auto mb-4 z-10 relative">
                                <button
                                    onClick={() => navigate('/calismalarimiz?category=corporate')}
                                    className="bg-slate-700 text-white px-8 py-2.5 rounded-lg text-sm font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                                    Görüntüle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="absolute -top-3 -right-3 bg-slate-400 rounded-full w-6 h-6 opacity-40 animate-bounce-slow"></div>
                <div className="absolute -bottom-4 -left-4 bg-blue-300 rounded-full w-8 h-8 opacity-30 animate-float"></div>
            </div>
        );
    }

    // Mezuniyet kategorisi için özel tasarım
    if (example.category === "Özel Gün") {
        return (
            <div className={`relative transform transition-all duration-500 ${scale} ${zIndex} ${opacity}`}>
                <div className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-[2.5rem] p-2 shadow-2xl hover:shadow-3xl transition-all duration-500">
                    <div className="bg-white rounded-[2rem] overflow-hidden w-60 h-[480px] relative shadow-inner">
                        <div className="bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50 h-full flex flex-col p-4 relative overflow-hidden">

                            {/* Arka plan konfeti */}
                            <div className="absolute top-8 left-4 w-2 h-2 bg-emerald-400 rounded-full opacity-60 animate-bounce"></div>
                            <div className="absolute top-12 right-6 w-1.5 h-1.5 bg-green-400 rounded-full opacity-70 animate-ping"></div>
                            <div className="absolute bottom-16 left-6 w-2.5 h-2.5 bg-teal-400 rounded-full opacity-50"></div>
                            <div className="absolute bottom-24 right-4 w-1 h-1 bg-emerald-500 rounded-full opacity-80"></div>

                            {/* Üst dekoratif çizgi */}
                            <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-dark-200 rounded-full"></div>

                            {/* Kategori etiketi */}
                            <div className="absolute top-6 right-3 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg backdrop-blur-sm border border-white/20 z-10">
                                Özel Gün
                            </div>

                            {/* Mezuniyet kep ikonu */}
                            <div className="flex justify-center mt-12 mb-3">
                                <div className="relative">
                                    <div className="w-12 h-8 bg-emerald-600 rounded-t-lg"></div>
                                    <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-14 h-1 bg-emerald-700"></div>
                                    <div className="absolute -bottom-2 right-0 w-6 h-6 bg-emerald-500 rounded-full">
                                        <div className="absolute top-1 left-1 w-1 h-4 bg-emerald-700"></div>
                                    </div>
                                </div>
                            </div>

                            {/* Ana başlık */}
                            <div className="text-center mb-4 z-10 relative">
                                <h2 className="text-xl font-bold text-dark-900 leading-tight">
                                    Sınıf 2025
                                </h2>
                                <p className="text-emerald-700 text-sm font-medium mt-1">
                                    Mezuniyet Töreni
                                </p>
                            </div>

                            {/* Mezuniyet detayları */}
                            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-3 mb-4 shadow-lg z-10 relative border border-emerald-200">
                                <div className="text-center mb-2">
                                    <p className="text-xs text-emerald-700">Mezuniyet Tarihi</p>
                                    <p className="text-sm font-bold text-dark-900">30 Haziran 2025</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-xs text-emerald-700">Üniversite</p>
                                    <p className="text-sm font-medium text-dark-800">İstanbul Teknik Üniversitesi</p>
                                </div>
                            </div>

                            {/* Özellikler */}
                            <div className="grid grid-cols-2 gap-2 mb-4 z-10 relative">
                                <div className="bg-emerald-100/80 rounded-lg p-2 text-center border border-emerald-200">
                                    <p className="text-xs font-medium text-emerald-800">Anılar</p>
                                </div>
                                <div className="bg-green-100/80 rounded-lg p-2 text-center border border-green-200">
                                    <p className="text-xs font-medium text-green-800">Video</p>
                                </div>
                                <div className="bg-teal-100/80 rounded-lg p-2 text-center border border-teal-200">
                                    <p className="text-xs font-medium text-teal-800">Sertifika</p>
                                </div>
                                <div className="bg-cyan-100/80 rounded-lg p-2 text-center border border-cyan-200">
                                    <p className="text-xs font-medium text-cyan-800">Kutlama</p>
                                </div>
                            </div>

                            {/* Görüntüle butonu */}
                            <div className="flex justify-center mt-auto mb-4 z-10 relative">
                                <button
                                    onClick={() => navigate('/calismalarimiz?category=graduation')}
                                    className="bg-emerald-600 text-white px-8 py-2.5 rounded-full text-sm font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                                    Görüntüle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="absolute -top-3 -right-3 bg-emerald-400 rounded-full w-6 h-6 opacity-40 animate-bounce-slow"></div>
                <div className="absolute -bottom-4 -left-4 bg-teal-300 rounded-full w-8 h-8 opacity-30 animate-float"></div>
            </div>
        );
    }

    // Varsayılan tasarım
    return (
        <div className={`relative transform transition-all duration-500 ${scale} ${zIndex} ${opacity}`}>
            <div className="bg-gradient-to-b from-dark-800 to-dark-900 rounded-[2.5rem] p-2 shadow-2xl hover:shadow-3xl transition-all duration-500">
                <div className="bg-white rounded-[2rem] overflow-hidden w-60 h-[480px] relative shadow-inner">
                    <div className={`bg-gradient-to-br ${example.bgGradient} h-full flex flex-col justify-center items-center p-5 relative`}>
                        <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-dark-200 rounded-full"></div>
                        <div className="absolute top-6 right-3 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg backdrop-blur-sm border border-white/20">
                            {example.category}
                        </div>
                        <div className="text-center mb-6">
                            <h3 className="text-lg font-bold text-dark-900 mb-1">{example.couple}</h3>
                            <p className="text-sm text-dark-600 font-medium mb-4">{example.title}</p>
                            <div className="w-14 h-14 bg-red-600 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4 shadow-xl border-2 border-white/30">
                                <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                </svg>
                            </div>
                        </div>
                        <div className="bg-white/80 backdrop-blur-sm rounded-xl p-3 w-full shadow-lg">
                            <div className="grid grid-cols-2 gap-2">
                                {example.features.map((feature, index) => (
                                    <div key={index} className="flex items-center space-x-2">
                                        <div className={`w-1.5 h-1.5 bg-red-500 rounded-full flex-shrink-0`}></div>
                                        <span className="text-xs text-dark-700 font-medium">{feature}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <button
                            onClick={() => navigate('/calismalarimiz')}
                            className="mt-4 bg-red-600 text-white px-6 py-2.5 rounded-full text-xs font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-white/20">
                            Görüntüle
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Examples; 